import AppAPI from "../../app/api";
import {getCompanyIDfromUrl} from "../../app/utils/route";
import {DarkmodeStyle} from "../../styles/darkmode";
import CompanyContacts from "./components/contacts";
import ViewTags from "./components/tags";
import {
    CompanyDescription,
    CompanyHeaderContainer,
    CompanyLogo,
    CompanyLogoContainer, CompanyPavilion,
    CompanyStand, CompanyStandPavilion,
    CompanyTitle,
    ViewBodyContainer,
    ViewHeaderContainer,
    ViewPageContainer
} from "./styles";
import {locale} from "./lang"
import i18n from "../../i18n";
import {localeFilter} from "../../components/filter/const";

export default function ViewPage() {
    const companyId = process.env.NODE_ENV === "production" ? getCompanyIDfromUrl() : 505
    const {data: company} = AppAPI.useGetCompanyInfoQuery(companyId!)
    const lang = i18n.language as "ru" | "en"

    if (!company) {
        return <></>
    }

    return (
        <ViewPageContainer>
            <DarkmodeStyle/>
            <ViewHeaderContainer>
                <CompanyHeaderContainer>
                    <CompanyLogoContainer>
                        <CompanyLogo src={lang=='ru'?company.log_url_ru:company.log_url_en}/>
                    </CompanyLogoContainer>
                    <CompanyTitle children={lang=='ru'?company.name:company.name_en}/>
                </CompanyHeaderContainer>

                <ViewTags activities={company.activities}/>

                <CompanyStandPavilion>
                    <CompanyStand children={locale.stand[lang]+': ' + (company.stend?company.stend:'')}/>
                    <CompanyPavilion children={locale.pavilion[lang]+': ' + (company.pavilion?company.pavilion:'')}/>
                </CompanyStandPavilion>

            </ViewHeaderContainer>

            <ViewBodyContainer>
                <CompanyDescription dangerouslySetInnerHTML={lang=='ru'?{__html: company.specification}:{__html: company.specification_en}}/>
                <CompanyContacts company={company}/>
            </ViewBodyContainer>
        </ViewPageContainer>
    )
}
